import i18next from 'i18next'

i18next.addResources('es', 'footer', {
  copyright: 'Copyright SURA 2023. Todos los derechos reservados',
  term: 'Términos y condiciones',
  privacy: '  Políticas de privacidad'
})
